/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import type { FC } from 'react';

import { Loader as DefaultLoader } from '@nexign/scc-ui-kit';
import type { TLoaderProps } from '@nexign/scc-ui-kit/lib/components/Loader/Loader';

import { loader } from '@theme/index';

export const KitLoader: FC<TLoaderProps> = ({ ...props }) => (
    <DefaultLoader customStyles={loader.customizeStyle} {...props} />
);
